import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

export default function CustomerSelect({ customers, value, onChange, testid = "customer-select", allowAll }) {
  return (
    <Select value={value || (allowAll ? "__all" : "")} onValueChange={(v) => onChange(v === "__all" ? "" : v)}>
      <SelectTrigger className="h-8 w-64 rounded-sm" data-testid={testid}>
        <SelectValue placeholder="Seleziona cliente" />
      </SelectTrigger>
      <SelectContent>
        {allowAll && <SelectItem value="__all">Tutti i clienti</SelectItem>}
        {customers.map((c) => (
          <SelectItem key={c.id} value={c.id} data-testid={`customer-option-${c.id}`}>{c.name}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
